import { render, staticRenderFns } from "./ContractAlertComponent.vue?vue&type=template&id=7c62de12&scoped=true&"
import script from "./ContractAlertComponent.vue?vue&type=script&lang=js&"
export * from "./ContractAlertComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c62de12",
  null
  
)

export default component.exports